import React, { useState, useEffect } from 'react'
import { GridReadyEvent, GridApi } from 'ag-grid-community'
import { Input } from '@chakra-ui/react'
import { PendingRenewal } from '@homevest/types/renewals'

import { BaseGrid } from 'components/TailwindUIToolkit'
import { PENDING_COLUMNS } from '../../Grid/pending-configuration'

interface RentalsToRenewTableProps {
  data: PendingRenewal[]
  setSelectedRental: (rental: any) => void
}

const RentalsToRenewTable: React.FC<React.PropsWithChildren<RentalsToRenewTableProps>> = ({
  data,
  setSelectedRental
}) => {
  const [searchQuery, setSearchQuery] = useState('')
  const [gridApi, setGridApi] = useState<GridApi<PendingRenewal>>()

  const onGridReady = (evt: GridReadyEvent<PendingRenewal>) => {
    setGridApi(evt.api)
  }

  const gridSetup = (evt: GridReadyEvent<PendingRenewal>) => {
    setGridApi(evt.api)
    onGridReady(evt)
  }

  useEffect(() => {
    if (gridApi && data) {
      gridApi.setQuickFilter(searchQuery)
      gridApi.onFilterChanged()
      try {
        gridApi.setRowData(data)
        gridApi.sizeColumnsToFit()
      } catch {
        console.log('Ran into an error drawing the grid, you may need to refresh the page')
      }
    }
  }, [gridApi, data, searchQuery])

  return (
    <>
      <Input
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder='Search by address, tenant, fund, etc.'
        type='text'
        value={searchQuery}
      />
      <div className='ag-theme-material right h-[50vh] border'>
        <BaseGrid<PendingRenewal>
          rowAutoHeight={true}
          columns={PENDING_COLUMNS}
          rowData={data}
          onGridReady={gridSetup}
          onRowClicked={(evt) => setSelectedRental(evt.data)}
          onGridSizeChanged={() => gridApi && gridApi.sizeColumnsToFit()}
        />
      </div>
    </>
  )
}

export default RentalsToRenewTable
